import { render } from "./Pattern_Product.vue?vue&type=template&id=448d0a12&scoped=true"
import script from "./Pattern_Product.vue?vue&type=script&lang=js"
export * from "./Pattern_Product.vue?vue&type=script&lang=js"

import "./Pattern_Product.vue?vue&type=style&index=0&id=448d0a12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448d0a12"],['__file',"src/views/pharmarcy/Pattern_Product.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "448d0a12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('448d0a12', __exports__)) {
    api.reload('448d0a12', __exports__)
  }
  
  module.hot.accept("./Pattern_Product.vue?vue&type=template&id=448d0a12&scoped=true", () => {
    api.rerender('448d0a12', render)
  })

}


export default __exports__